import { exists } from '@/api'

// labelは必須、groupsかdataどちらかが渡される仕様
export interface NdcList {
  label: string
  groups?: NdcList[]
  data?: string
}

export function NdcListFromJSON(json: any): NdcList {
  const result = {
    label: exists(json, 'label') ? json.label : ''
  }

  if (exists(json, 'groups')) {
    return { ...result, groups: json.groups.map(NdcListFromJSON) }
  }

  if (exists(json, 'data')) {
    return { ...result, data: json.data }
  }

  // ここに辿り着く、つまりgroupsとdataがどちらも渡されていないのは意図した動きではないので注意
  return result
}
